// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/common/style/vitae.less
// module id = 658
// module chunks = 0